module.exports = __webpack_public_path__ + "static/img/5.c95daa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/5.png
// module id = uv4Y
// module chunks = 0